/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { TextAreaStyle } from "@insite/mobius/TextArea";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { rfqQuoteDetailsMessagesStyles } from "@monsma/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { css } from "styled-components";

rfqQuoteDetailsMessagesStyles.mainWrapper = {
    css: css`
        ${rfqQuoteDetailsMessagesStyles.mainWrapper?.css};
        padding: 0;
    `,
};

rfqQuoteDetailsMessagesStyles.messageTextArea = {
    cssOverrides: {
        formField: css`
            @media print {
                display: none;
            }
            > ${TypographyStyle} {
                font-size: 15px;
            }
        `,
        formInputWrapper: css`
            &&&& {
                margin-top: 8px;

                ${TextAreaStyle}:active, ${TextAreaStyle}:focus {
                    padding: 10px;
                }
            }
        `,
    },
};

rfqQuoteDetailsMessagesStyles.sendButton = {
    css: css`
        margin-top: 20px;
    `,
};

rfqQuoteDetailsMessagesStyles.xRfqQuoteDetailsMessagesStyles = {
    messagePanel: {
        wrapper: {
            css: css`
                margin-top: 10px;
                width: 100%;
            `,
        },
        content: {
            size: "15px",
            lineHeight: "20px",
            css: css`
                a {
                    span {
                        font-size: 13px;
                    }
                }
            `,
        },
    },
};
